import { createClient } from '@supabase/supabase-js';

// Configuration Supabase
// On utilise une approche défensive pour lire les variables d'environnement
// afin d'éviter le crash "Cannot read properties of undefined" si import.meta.env n'est pas défini
const env = (import.meta as any).env;

const supabaseUrl = (env && env.VITE_SUPABASE_URL) || 'https://zxshwcuagslowcjokjhp.supabase.co';
const supabaseKey = (env && env.VITE_SUPABASE_ANON_KEY) || 'sb_publishable_LFwDASIISC1vuSsIbh6mQw_zbL8Xndh';

export const supabase = createClient(supabaseUrl, supabaseKey);

// Helper pour les URLs de fichiers
export const getStorageUrl = (path: string) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  const { data } = supabase.storage.from('lock-files').getPublicUrl(path);
  return data.publicUrl;
};